import CryptoJS from 'crypto-js'

// 密钥和偏移量 (建议使用环境变量存储)
const KEY = 'dashoo123456abcd' // 16位
const IV = 'dashoo123456abcd'   // 16位

export default {
  // AES加密
  encrypt(word) {
    const key = CryptoJS.enc.Utf8.parse(KEY)
    const iv = CryptoJS.enc.Utf8.parse(IV)
    const srcs = CryptoJS.enc.Utf8.parse(word)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  },

  // AES解密
  decrypt(word) {
    const key = CryptoJS.enc.Utf8.parse(KEY)
    const iv = CryptoJS.enc.Utf8.parse(IV)

    const decrypt = CryptoJS.AES.decrypt(word, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  }
}



// WEBPACK FOOTER //
// ./src/libraries/utils/crypto.js